import { useRecoilState, useRecoilValue } from "recoil";
import { REDEMPTION_FEE } from "config/config";
import { cartItemCountState, cartState } from "atoms/atoms";

const useCart = () => {
  const [basket, setBasket] = useRecoilState(cartState);
  const basketItemCount = useRecoilValue(cartItemCountState);

  // Termék hozzáadása a kosárhoz
  const addToBasket = (product) => {
    setBasket(prevBasket => {
      const existingIndex = prevBasket.findIndex(
        item => item.item_no === product.item_no && item.size === product.size
      );

      if (existingIndex >= 0) {
        const newBasket = [...prevBasket];
        newBasket[existingIndex] = {
          ...newBasket[existingIndex],
          quantity: newBasket[existingIndex].quantity + product.quantity
        };
        return newBasket;
      }
      return [...prevBasket, product];
    });
  };

  // Termék eltávolítása
  const removeFromBasket = (itemNo, size) => {
    setBasket(prevBasket =>
      prevBasket.filter(item => !(item.item_no === itemNo && item.size === size))
    );
  };

  // Mennyiség módosítása
  const updateQuantity = (itemNo, size, newQuantity) => {
    setBasket(prevBasket =>
      prevBasket.map(item =>
        item.item_no === itemNo && item.size === size
          ? { ...item, quantity: Math.max(1, newQuantity) }
          : item
      )
    );
  };

  // Kosár ürítése
  const clearBasket = () => {
    setBasket([]);
  };

  // Összesített érték számítása
  const getTotalPrice = () => {
    return basket.reduce((total, item) => {
      const unitPrice = item.discount_price > 0 ? item.discount_price : item.price;
      return total + unitPrice * item.quantity;
    }, 0);
  };

  // Visszaváltási díj számítása
  const getRedemptionFee = () => {
    return basket.reduce((total, item) => {
      return total + (item.redemption_fee ? REDEMPTION_FEE * item.quantity : 0);
    }, 0);
  };

  return {
    basket,
    addToBasket,
    removeFromBasket,
    updateQuantity,
    clearBasket,
    getTotalPrice,
    getRedemptionFee,
    basketItemCount
  };
};

export default useCart;
